import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/authService';
import { ToastrcustomService } from '../../services/toasterService';
import { PORTAL_IDENTITY } from '../../enviroments/settings';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.scss',
})
export class SigninComponent implements OnInit, AfterViewInit, OnDestroy {
  form: FormGroup;
  showPassword = true;
  isSubmitted = false;
  isLoading = false;
  portalName: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrcustomService
  ) {
    this.form = this.formBuilder.group({
      Email: [''],
      Password: [''],
    });
  }
  ngOnInit(): void {
    this.getportal();
    this.form = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required]],
    });
  }

  ngAfterViewInit(): void {}
  ngOnDestroy(): void {}

  get errorControl() {
    return this.form.controls;
  }

  onSubmit(): void {
    this.isSubmitted = true;

    if (this.form.invalid) {
      return;
    }

    if (this.form.status == 'VALID') {
      this.isLoading = true;

      const email = this.form.controls['Email'].value;
      const password = this.form.controls['Password'].value;

      const requestBody = {
        portal_id: PORTAL_IDENTITY,
        email: email,
        password: password,
      };console.log(requestBody, PORTAL_IDENTITY);
      

      this.authService.userlogin(requestBody).subscribe(
        (response) => {
          console.log('Login : ', response);
          if (response.data.status === '200') {
            localStorage.clear();
            this.authService.saveToken(response.token);
            this.authService.saveUserDetail(response.user);
            this.router.navigate(['dashboard']);
            this.isLoading = false;
            this.toastrService.showSuccess('Login successfully', 'Success');
          } else {
            this.toastrService.showError(response.data.logs, 'Failed');
            this.isLoading = false;
          }
        },
        (error) => {
          console.error('Login error:', error);
          this.isLoading = false;
        }
      );
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  getportal(): void {
    this.authService.getportal().subscribe(
      (response) => {
        console.log(response);
        document.documentElement.style.setProperty(
          '--primary-color',
          response.primary_color.toLowerCase()
        );
        document.documentElement.style.setProperty(
          '--secondary-color',
          response.secondary_color.toLowerCase()
        );
        document.documentElement.style.setProperty(
          '--default-logo',
          response.logo
        );
        document.documentElement.style.setProperty(
          '--default-favicon',
          response.favicon
        );
        this.updateFavicon(response.favicon);
        this.updateMetaTags(response.meta_title, response.meta_description);
        this.portalName = response.name;
      },
      (error) => {
        console.log('Get Portal : ', error);
      }
    );
  }

  getPrimaryLogo() {
    const primaryLogo = getComputedStyle(document.documentElement)
      .getPropertyValue('--default-logo')
      .trim();
    return primaryLogo;
  }

  private updateFavicon(faviconUrl: string): void {
    const linkElement = document.querySelector("link[rel='icon']");
    if (linkElement && faviconUrl) {
      linkElement.setAttribute('href', faviconUrl);
    }
  }

  private updateMetaTags(title: string, description: string): void {
    const titleElement = document.querySelector('title');
    if (titleElement && title) {
      titleElement.innerText = title;
    }

    const descriptionElement = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionElement && description) {
      descriptionElement.setAttribute('content', description);
    }
  }
}
